import { ORG_PERMISSIONS } from 'utils/permissions';
import { NAVBAR_PROJECT_SETTINGS, NavbarOption } from '../types';

export const ORGANIZATION_LINKS: NavbarOption[] = [
  {
    title: 'Organization Members',
    href: '/members',
    rbacPermission: ORG_PERMISSIONS.ManageMembers,
  },
  {
    title: 'Roles',
    href: '/roles',
    rbacPermission: ORG_PERMISSIONS.ManageRoles,
  },
  {
    title: 'Authentication',
    href: '/settings/authentication',
    rbacPermission: ORG_PERMISSIONS.ManageMembers,
  },
  {
    /**
     * this is not an external page. but for the moment, we want to do a hard refresh on this page.
     * see: https://iterable.atlassian.net/browse/EN-167
     */
    isExternal: true,
    title: 'Usage and Billing',
    href: '/payments/info',
    rbacPermission: ORG_PERMISSIONS.ManageBilling,
  },
  {
    featureFlags: ['LinkExpirationManagement'],
    title: 'Link Expiration Management',
    href: '/settings/linkExpirationManagement',
    /** requires org admin access controlled with projectSettings, adding all org permissions as an additional check */
    rbacPermission: Object.values(ORG_PERMISSIONS),
    projectSettings: [NAVBAR_PROJECT_SETTINGS.orgAdmin],
  },
];
